import React, { useContext } from 'react';
import { KFLRadioButton } from '@kamstrup/kamstrup-frontend-library';
import * as Download from '../../../modules/dialogs/download';
import * as m from '../../../modules/dialogs/download/messages';
import { Groups, SelectMode } from '../../../models';
import Translate from '../../shared/localization/localize';
import { LocaleCtx } from '../../../contexts/locale.context';
import Badge from '../../shared/badge';

type DownloadModeType = Download.Data & Download.View;
const DownloadMode: React.FC<DownloadModeType> = ({
  groupedBy,
  mode,
  keys,
}) => {
  const { translate } = useContext(LocaleCtx);
  const numKeys = keys.length;
  const selectedKey = numKeys === 1 ? String(keys[0]) : '';
  const viewMsg = m.getViewMsg(groupedBy, numKeys);

  return groupedBy === Groups.DEVICES ? (
    <div className="donwload_modes">
      <span className="download_mode_opt">
        <KFLRadioButton
          checked={mode === SelectMode.Selected}
          disabled={keys.length === 0}
          id="download-mode-selected"
          label={translate(m.msgDevicesSelected)}
          name="download-selection"
          onChange={() => Download.setMode(groupedBy, SelectMode.Selected)}
        />
        <span className="num_devices">
          {keys.length > 0 && <Badge lightTheme>{keys.length}</Badge>}
        </span>
      </span>
      <KFLRadioButton
        checked={mode === SelectMode.All}
        id="download-mode-all"
        label={translate(m.msgDevicesAll)}
        name="download-selection"
        onChange={() => Download.setMode(groupedBy, SelectMode.All)}
      />
    </div>
  ) : (
    <div>
      <Translate message={viewMsg} />
      <strong>{selectedKey ? ` ${selectedKey}` : ''}</strong>
    </div>
  );
};

export default DownloadMode;
